import React, { useState } from 'react';
import Login from './Login';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import Header from './Header';
import UserList from './GestioneUtenti';
import './Header.css'; //
import './table.css'; //
import { AuthProvider } from './AuthContext'; // Importa il contesto
import Footer from './Footer';
import CreaEvento from './CreaEvento';
import CreaUtente from './CreaUtente';
import EventList from './GestioneEventi';
import ProfilePage from './ProfilePage';
import ProfilePageAdmnin from './ProfilePageAdminn';
const App = () => {
  const [jwtToken, setJwtToken] = useState('');

  const handleLogin = (token) => {
    setJwtToken(token);
    // Puoi implementare ulteriori logiche di gestione dell'autenticazione qui, ad esempio il reindirizzamento a un'altra pagina.
  };

  return (
    <AuthProvider>
    <div>
      

      <Router>
      <Header />
      <Routes>
  <Route path="/" element={<HomePage />} />
  <Route path="/about" element={<AboutPage />} />
  <Route path="/crea" element={<CreaEvento />} />
  <Route path="/creaUtente" element={<CreaUtente />} />
  <Route path="/listaUtenti" element={<UserList />} />
  <Route path="/events" element={<EventList />} />
  <Route path="/user/:id" element={<ProfilePageAdmnin />} />
  <Route path="/package" element={<UserList />} />
  <Route path="/profile" element={<ProfilePage />} />
  <Route path="/login" element={<Login onLogin={handleLogin} />} />
</Routes>


            </Router>
    </div>
    </AuthProvider>
    
  );
};

export default App;
